var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationDayStreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFF4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1104 27.2754C26.4987 28.4264 25.4277 29.399 24.2641 30.0876C23.7483 30.3924 23.2112 30.6554 22.6577 30.8741C24.4257 29.0422 25.0501 26.324 23.3239 24.2254C23.1945 24.9473 22.869 25.6139 22.3872 26.1437C22.1476 23.3814 19.4556 21.9043 19.4628 19.8134C16.0302 23.0744 14.8122 28.5645 18.1541 30.9873C17.7474 30.8588 17.3154 30.7168 16.9251 30.548C15.9226 30.0935 15.0127 29.4382 14.2459 28.6182C6.61641 20.5807 20.1327 8.26731 20.08 7.5C19.962 9.03462 21.0603 14.2139 22.6413 16.0651C22.9572 15.4896 23.7178 14.4173 24.3222 14.0777C23.3384 16.4123 30.6465 20.6517 27.1195 27.2754H27.1104Z",
    fill: "#FCB44D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.145 31.1741C19.591 31.6339 21.131 31.6066 22.5625 31.0958L22.6092 31.0489C24.3611 29.1775 24.9798 26.398 23.2711 24.2643C23.1427 25.0006 22.821 25.6805 22.3448 26.2218C22.1038 23.4031 19.4382 21.8958 19.4436 19.7563C16.0424 23.0938 14.8355 28.6882 18.1486 31.1604L18.145 31.1741Z",
    fill: "#E7504E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDayStreak);
export default __webpack_public_path__ + "static/media/notification-day-streak.d9baf69c6400679f7fe70fd93afe8527.svg";
export { ForwardRef as ReactComponent };